import { UniformSeason } from '@/model';
import {
  GetMediaUniformSeasonByIdResponse,
  GetMediaUniformSeasonResponse,
  PostMediaUniformSeasonResponse,
  PutMediaUniformSeasonResponse,
} from '@/services/response/uniform-season';

export class UniformSeasonConverter {
  static toDomainFromGetResponse(response: GetMediaUniformSeasonResponse): UniformSeason[] {
    return response.map(item => ({
      uuid: item.uuid,
      status: item.status,
      title: item.title,
      business_unit_uuid: item.business_unit_uuid,
      created_at: item.created_at,
      updated_at: item.updated_at,
    }));
  }

  static toDomainFromPostResponse(response: PostMediaUniformSeasonResponse): UniformSeason {
    return {
      uuid: response.uuid,
      status: response.status,
      title: response.title,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromByIdResponse(response: GetMediaUniformSeasonByIdResponse): UniformSeason {
    return {
      uuid: response.uuid,
      status: response.status,
      title: response.title,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPutResponse(response: PutMediaUniformSeasonResponse): UniformSeason {
    return {
      uuid: response.uuid,
      status: response.status,
      title: response.title,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }
}
